import { Minus, Plus } from 'lucide-react'

import { cn } from '@/lib/utils'

interface QtyStepperProps {
  value: number
  /** Returns cap at what is left to return; sales have no cap (stock may go negative). */
  max?: number
  onChange: (value: number) => void
  /** Sold by unit: decimals can be typed (2.5 kg); the buttons still step by one. */
  decimal?: boolean
  className?: string
}

const step = 'grid size-9 place-items-center text-ink transition-colors hover:bg-fill disabled:opacity-30'

/** 36px targets on each side; the middle is typeable for "12 of these". Going below 1 removes the line. */
export const QtyStepper = ({ value, max, onChange, decimal, className }: QtyStepperProps) => (
  <div className={cn('inline-flex h-9 shrink-0 items-center overflow-hidden rounded-xs border border-input bg-card', className)}>
    <button type="button" className={step} onClick={() => onChange(value - 1)} aria-label="Decrease quantity">
      <Minus className="size-4" />
    </button>
    <input
      value={value}
      inputMode={decimal ? 'decimal' : 'numeric'}
      aria-label="Quantity"
      onFocus={(e) => e.target.select()}
      onChange={(e) => {
        const n = decimal ? parseFloat(e.target.value.replace(/[^\d.]/g, '')) : parseInt(e.target.value.replace(/\D/g, ''), 10)
        if (!Number.isNaN(n)) onChange(n)
      }}
      className={cn('h-full bg-transparent text-center text-sm font-semibold tabular-nums text-ink outline-none', decimal ? 'w-14' : 'w-9')}
    />
    <button type="button" className={step} disabled={max !== undefined && value >= max} onClick={() => onChange(value + 1)} aria-label="Increase quantity">
      <Plus className="size-4" />
    </button>
  </div>
)
